module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/voice-03-e85efb4ac006fa4757028238496de06c.svg";